export type PasswordCriterion = {
  key: 'minLength' | 'lowercase' | 'uppercase' | 'digit' | 'specialChar';
  met: boolean;
};

export function getPasswordStrength(password: string): PasswordCriterion[] {
  return [
    { key: 'minLength', met: password.length >= 12 },
    { key: 'lowercase', met: /[a-z]/.test(password) },
    { key: 'uppercase', met: /[A-Z]/.test(password) },
    { key: 'digit', met: /[0-9]/.test(password) },
    { key: 'specialChar', met: /[^a-zA-Z0-9]/.test(password) },
  ];
}
